import {defineStore} from 'pinia'

export const usePerqStore = defineStore('perq', {
  state: () => ({
    response: {}
  }),
  getters: {
    getResponse: state => state.response
  },
  actions: {
    setResponse(response) {
      this.response = response
    },
    clearResponse() {
      this.response = {}
    }
  },
  persist: {
    storage: persistedState.localStorage
  }
})
